export const isValidSubdomain = val => {
  const regex = /[^a-zA-Z0-9-]/;
  return val && val.length > 0 && val.length <= 60 && !regex.test(val);
};
